
import { StatSection } from '@/components/Metrics'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ListSection',
  components: { StatSection },
  props: {
    allowLoadMore: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    helpText: {
      type: String,
      default: undefined
    },
    footerLink: {
      type: String,
      default: undefined
    },
    footerLinkLabel: {
      type: String,
      default: undefined
    }
  }
})
